import { getAxiosInstance } from '../../services/axiosInstance';
import { getScimConfig } from '../../utils/envUtils';

/** GET decrypted value for an encrypted attribute (mgmt/encdec). */
export async function fetchDecryptedAttributeValue(
    entityId: string,
    attributePath: string
): Promise<string> {
    const api = getAxiosInstance(getScimConfig().apiUrl);
    const path = `mgmt/encdec/${encodeURIComponent(entityId)}/${attributePath}`;
    const res = await api.get(path);
    const data = res.data;
    const raw = data?.Value ?? data?.value;
    if (raw === undefined || raw === null) return '';
    return typeof raw === 'string' ? raw : JSON.stringify(raw);
}

export function decryptErrorMessage(err: unknown): string {
    return (
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
        (err as Error)?.message ??
        'Failed to decrypt'
    );
}
